/**
 * @generated SignedSource<<1993bde75c6665efae9fbe9dfd608414>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type RoutineType = "DEFAULT" | "EVENT_ITEM" | "KPI" | "STANDARD" | "TEMPLATE";
export type WidgetTaskSingleGroupingMode = "SECTION" | "TEAM";
export type WidgetTaskSingleSize = "ONE_X_ONE" | "TWO_X_ONE";
import { FragmentRefs } from "relay-runtime";
export type WidgetTaskSingle_widgetTaskSingle$data = {
  readonly activeSectionVersions: ReadonlyArray<{
    readonly section: {
      readonly id: string;
    };
  }>;
  readonly grouping: WidgetTaskSingleGroupingMode | null;
  readonly id: string;
  readonly task: {
    readonly __typename: string;
    readonly id: string;
    readonly routine: {
      readonly id: string;
      readonly title: string;
      readonly type: RoutineType;
    };
    readonly " $fragmentSpreads": FragmentRefs<"WidgetTaskSingleCheck_taskCheck" | "WidgetTaskSingleNumberOccasionPage_taskNumber">;
  } | null;
  readonly taskSingleSize: WidgetTaskSingleSize;
  readonly title: string;
  readonly " $fragmentSpreads": FragmentRefs<"useWidgetTaskSingleSections_widgetTaskSingle">;
  readonly " $fragmentType": "WidgetTaskSingle_widgetTaskSingle";
};
export type WidgetTaskSingle_widgetTaskSingle$key = {
  readonly " $data"?: WidgetTaskSingle_widgetTaskSingle$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetTaskSingle_widgetTaskSingle">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetTaskSingle_widgetTaskSingle",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "grouping",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "taskSingleSize",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useWidgetTaskSingleSections_widgetTaskSingle"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RoutineSectionVersion",
      "kind": "LinkedField",
      "name": "activeSectionVersions",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "RoutineSection",
          "kind": "LinkedField",
          "name": "section",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "task",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Routine",
          "kind": "LinkedField",
          "name": "routine",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "type",
              "storageKey": null
            },
            (v1/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "WidgetTaskSingleNumberOccasionPage_taskNumber"
            }
          ],
          "type": "TaskNumber",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "WidgetTaskSingleCheck_taskCheck"
            }
          ],
          "type": "TaskCheck",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "WidgetTaskSingle",
  "abstractKey": null
};
})();

(node as any).hash = "ced34237fb6d0262c9af32ebcdc25ba4";

export default node;
